import { useQuery } from '@tanstack/react-query';
import { bdLocationService } from '../bdLocationService';

export function useDivisions() {
  return useQuery({
    queryKey: ['bd-divisions'],
    queryFn: () => bdLocationService.getDivisions(),
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  });
}

export function useDistricts(divisionId: string | undefined) {
  return useQuery({
    queryKey: ['bd-districts', divisionId],
    queryFn: () => bdLocationService.getDistrictsByDivision(divisionId!),
    enabled: !!divisionId,
    staleTime: 1000 * 60 * 60 * 24,
    placeholderData: undefined,
  });
}

export function useUpazilas(districtId: string | undefined) {
  return useQuery({
    queryKey: ['bd-upazilas', districtId],
    queryFn: () => bdLocationService.getUpazilasByDistrict(districtId!),
    enabled: !!districtId,
    staleTime: 1000 * 60 * 60 * 24,
    placeholderData: undefined,
  });
}

export function useUnions(upazillaId: string | undefined) {
  return useQuery({
    queryKey: ['bd-unions', upazillaId],
    queryFn: () => bdLocationService.getUnionsByUpazila(upazillaId!),
    enabled: !!upazillaId,
    staleTime: 1000 * 60 * 60 * 24,
    placeholderData: undefined,
  });
}
